import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { Helper } from '../../common/helpers/Helper';
import { VenueHealthDashboard } from './VenueHealthDashboard';
import { ScreenHealthTimeseriesReport } from './ScreenHealthTimeseriesReport';
import { ApiHelper } from '../../common/helpers/ApiHelper';

const queryString = require('query-string');
const FLEET_TAB = 'fleet';
const HISTORY_TAB = 'history';

export class ScreenHealthSummary extends BaseEntityPage {
  pageKey = 'ScreenHealthSummary';
  pageTitle = Helper.getString('screenHealthSummary');
  noAdd = true;

  constructor(props, options) {
    super(props, options);
    const screen = this.getScreenFromLocation(props.location.search);
    this.historySearch = screen ? this.getHistorySearch(props.location.search) : '';
    this.state = {
      ...this.state,
      fetchState: ApiHelper.State.READY,
      screen,
      showHistory: Boolean(screen)
    };
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: Helper.getString('screenHealthSummary') }
    ];
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      const screen = this.getScreenFromLocation(this.props.location.search);
      if (screen) this.historySearch = this.getHistorySearch(this.props.location.search);
      if (screen !== this.state.screen) {
        this.setState({ screen, showHistory: Boolean(screen) });
      }
    }
  }

  getScreenFromLocation = (search) => {
    const query = queryString.parse(search);
    return (query.screen || query.ddCode || query.venueCode || '').trim();
  }

  getHistorySearch = (search) => {
    const query = queryString.parse(search);
    delete query.tab;
    const historySearch = queryString.stringify(query);
    return historySearch ? `?${historySearch}` : '';
  };

  onTabChange = (event, activeTab) => {
    if (activeTab === FLEET_TAB) {
      if (this.state.screen) this.historySearch = this.getHistorySearch(this.props.location.search);
      this.setState({ showHistory: false }, () => {
        this.props.history.replace('/admin/screen-health-summary');
      });
      return;
    }

    this.setState({ showHistory: true }, () => {
      if (this.historySearch) {
        this.props.history.replace(`/admin/screen-health-summary${this.historySearch}`);
      }
    });
  };

  renderAboveTable() {
    const activeTab = this.state.showHistory ? HISTORY_TAB : FLEET_TAB;
    return (
      <div className={css(Styles.contentWrap)}>
        <div className={css(Styles.tabsWrap)}>
          <Tabs
            value={activeTab}
            onChange={this.onTabChange}
            classes={{ root: css(Styles.tabs), indicator: css(Styles.tabIndicator) }}
          >
            <Tab
              disableRipple
              value={FLEET_TAB}
              label={Helper.getString('fleetSnapshot')}
              style={{ minWidth: 0, padding: '6px 0', marginRight: 16 }}
              classes={{
                root: css(Styles.tab),
                wrapper: css(Styles.tabLabel),
                selected: css(Styles.selectedTab)
              }}
            />
            <Tab
              disableRipple
              value={HISTORY_TAB}
              label={Helper.getString('screenHistory')}
              style={{ minWidth: 0, padding: '6px 0' }}
              classes={{
                root: css(Styles.tab),
                wrapper: css(Styles.tabLabel),
                selected: css(Styles.selectedTab)
              }}
            />
          </Tabs>
        </div>
        {this.renderContent()}
      </div>
    );
  }

  renderContent = () => {
    if (this.state.showHistory) {
      return (
        <ScreenHealthTimeseriesReport
          key='screen-health-history'
          {...this.props}
          embedded
          routePathOverride='/admin/screen-health-summary'
        />
      );
    }

    return (
      <VenueHealthDashboard
        key='venue-health-dashboard'
        {...this.props}
        embedded
      />
    );
  }
}

const Styles = StyleSheet.create({
  tabsWrap: {
    width: '100%',
    marginBottom: 4,
    borderBottom: '1px solid #e5e7eb'
  },
  tabs: {
    minHeight: 42
  },
  tabLabel: {
    alignItems: 'flex-start !important',
    textAlign: 'left !important',
    width: '100%'
  },
  tab: {
    color: 'rgb(102, 102, 102)',
    fontSize: '16px',
    fontWeight: '600',
    textTransform: 'none'
  },
  selectedTab: {
    color: '#0b32d9 !important',
    boxShadow: 'inset 0 -2px 0 #3157ff'
  },
  tabIndicator: {
    display: 'none'
  },
  contentWrap: {
    width: '100%'
  }
});



// WEBPACK FOOTER //
// ./src/screens/admin/ScreenHealthSummary.js